import { ApiReportReportTypeChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";
import { useIsReportHandlebars, useIsReviewPage } from "@components/ReportField/capabilities/flags";
import { useReport } from "@providers/ReportProvider";

// Whether "Move to Section" (cross-page reassign) shows. Legacy offered it only
// for handlebars exports; evaluation had no cross-page move (its appendix move is
// handled by useCanMoveToAppendix).
export const useCanMoveToSection = (_section: ReportSectionsType): boolean => {
  const { report, viewMode } = useReport();
  const isReviewPage = useIsReviewPage();
  const isHandlebars = useIsReportHandlebars();

  const reportType = report.reportType;

  if (reportType === ApiReportReportTypeChoices.InitialAssessment) {
    return isHandlebars && !isReviewPage;
  }
  if (reportType === ApiReportReportTypeChoices.DiagnosisEvaluation && viewMode === "step") {
    return false;
  }
  return isHandlebars;
};
